import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Bitrix24 = (props: TIconProps): ReactElement => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.995"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8187 0.963379C13.5981 0.963379 14.3775 0.963379 15.1569 0.963379C19.7134 1.5168 23.1443 3.77022 25.4497 7.72363C26.2983 9.32326 26.815 11.0175 27 12.8065C27 13.5859 27 14.3653 27 15.1447C26.4466 19.7012 24.1932 23.1321 20.2398 25.4375C18.6401 26.2861 16.9458 26.8028 15.1569 26.9878C14.3775 26.9878 13.5981 26.9878 12.8187 26.9878C8.26222 26.4344 4.83128 24.181 2.52587 20.2275C1.67729 18.6279 1.16053 16.9336 0.975586 15.1447C0.975586 14.3653 0.975586 13.5859 0.975586 12.8065C1.52901 8.25001 3.78243 4.81907 7.73583 2.51366C9.33547 1.66509 11.0298 1.14833 12.8187 0.963379Z"
      fill="hsl(from hsl(203 90% 47%) h s 49%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8839 15.1448C19.7814 15.0724 19.6629 15.0385 19.5281 15.0431C18.2983 14.5505 17.7391 13.6356 17.8507 12.2983C17.9231 12.1959 17.9569 12.0773 17.9524 11.9425C18.412 10.7637 19.2761 10.1961 20.5446 10.2398C21.8931 10.5038 22.6386 11.317 22.7811 12.6796C22.5711 14.389 21.6053 15.2108 19.8839 15.1448Z"
      fill="hsl(from hsl(203 90% 47%) h s 99%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22757 16.3645C7.19997 16.3676 7.18304 16.3845 7.17674 16.4154C8.29447 16.4662 9.4127 16.4831 10.5314 16.4662C10.5314 16.8728 10.5314 17.2795 10.5314 17.6861C8.76936 17.6861 7.00733 17.6861 5.24524 17.6861C5.24524 17.6183 5.24524 17.5505 5.24524 17.4828C5.40502 16.2228 5.98108 15.1978 6.97342 14.4076C7.52166 14.0119 8.05537 13.5968 8.57453 13.1623C8.87641 12.8033 8.92724 12.4136 8.72702 11.9932C8.58582 11.8252 8.40792 11.715 8.19332 11.6629C7.38346 11.5561 6.62103 11.7001 5.90602 12.0949C5.74616 11.7427 5.61061 11.3784 5.49938 11.0021C5.80965 10.7963 6.14852 10.6438 6.51596 10.5446C7.51241 10.2793 8.49514 10.3132 9.46404 10.6463C10.2653 11.1226 10.5787 11.8258 10.4044 12.7557C10.3099 13.0631 10.1744 13.3512 9.99774 13.6198C9.37387 14.2775 8.68768 14.8621 7.93917 15.3734C7.63044 15.656 7.39327 15.9864 7.22757 16.3645Z"
      fill="hsl(from hsl(203 90% 47%) h s 99%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1734 15.9579C15.8007 15.9579 15.4279 15.9579 15.0552 15.9579C15.0552 16.5339 15.0552 17.11 15.0552 17.6861C14.5808 17.6861 14.1064 17.6861 13.632 17.6861C13.632 17.11 13.632 16.5339 13.632 15.9579C12.5307 15.9579 11.4294 15.9579 10.3281 15.9579C10.3197 15.6355 10.3281 15.3136 10.3535 14.9921C11.5588 13.4541 12.7702 11.9208 13.9878 10.3921C14.3602 10.3667 14.7329 10.3583 15.106 10.3667C15.106 11.8407 15.106 13.3148 15.106 14.7888C15.4618 14.7888 15.8176 14.7888 16.1734 14.7888C16.1734 15.1785 16.1734 15.5682 16.1734 15.9579Z"
      fill="hsl(from hsl(203 90% 47%) h s 99%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9347 10.6716C21.0616 10.6201 21.8326 11.1115 22.2474 12.1457C22.4412 13.3764 21.9583 14.2151 20.7988 14.6617C19.5752 14.8611 18.7535 14.3782 18.3336 13.2131C18.1619 11.9118 18.6956 11.0646 19.9347 10.6716Z"
      fill="hsl(from hsl(203 90% 47%) h s 49%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5447 12.3999C20.8059 12.4501 21.077 12.467 21.3579 12.4507C21.3579 12.6032 21.3579 12.7557 21.3579 12.9081C20.9174 12.9081 20.4769 12.9081 20.0364 12.9081C20.0364 12.4507 20.0364 11.9932 20.0364 11.5358C20.1889 11.5358 20.3414 11.5358 20.4938 11.5358C20.4775 11.8335 20.4944 12.1216 20.5447 12.3999Z"
      fill="hsl(from hsl(203 90% 47%) h s 100%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5447 12.3999C20.4944 12.1216 20.4775 11.8336 20.4938 11.5358C20.3413 11.5358 20.1889 11.5358 20.0364 11.5358C20.0364 11.9933 20.0364 12.4507 20.0364 12.9082C19.9859 12.443 19.9689 11.9686 19.9855 11.485C20.1719 11.485 20.3583 11.485 20.5447 11.485C20.5447 11.79 20.5447 12.0949 20.5447 12.3999Z"
      fill="hsl(from hsl(203 90% 47%) h s 87%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9525 11.9424C17.9571 12.0772 17.9233 12.1958 17.8509 12.2982C17.8463 12.1634 17.8801 12.0448 17.9525 11.9424Z"
      fill="hsl(from hsl(203 90% 47%) h s 89%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5447 12.3999C20.8327 12.3999 21.1207 12.3999 21.4088 12.3999C21.4247 12.5799 21.4077 12.7494 21.3579 12.9082C21.3579 12.7557 21.3579 12.6032 21.3579 12.4507C21.0771 12.467 20.8059 12.4501 20.5447 12.3999Z"
      fill="hsl(from hsl(203 90% 47%) h s 85%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5812 12.7557C13.6301 12.8455 13.647 12.9471 13.632 13.0607C13.632 13.1624 13.632 13.264 13.632 13.3657C13.5816 13.8139 13.5646 14.2714 13.5812 14.7381C13.0807 14.7547 12.5893 14.7378 12.1072 14.6872C12.5991 14.0415 13.0905 13.3976 13.5812 12.7557Z"
      fill="hsl(from hsl(203 90% 47%) h s 49%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.632 13.0607C13.647 12.9471 13.63 12.8454 13.5812 12.7557C13.5956 12.7156 13.621 12.6817 13.6574 12.6541C13.6981 12.7998 13.6896 12.9353 13.632 13.0607Z"
      fill="hsl(from hsl(203 90% 47%) h s 86%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.632 13.3656C13.632 13.84 13.632 14.3144 13.632 14.7888C13.1056 14.8057 12.5804 14.7888 12.0563 14.738C12.0626 14.7071 12.0795 14.6902 12.1071 14.6872C12.5893 14.7377 13.0806 14.7546 13.5811 14.738C13.5645 14.2713 13.5815 13.8138 13.632 13.3656Z"
      fill="hsl(from hsl(203 90% 47%) h s 81%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5282 15.043C19.663 15.0384 19.7816 15.0723 19.884 15.1447C19.7492 15.1492 19.6306 15.1154 19.5282 15.043Z"
      fill="hsl(from hsl(203 90% 47%) h s 88%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3281 15.9579C11.4294 15.9579 12.5307 15.9579 13.632 15.9579C13.632 16.5339 13.632 17.11 13.632 17.6861C13.632 17.703 13.632 17.72 13.632 17.7369C13.5814 17.17 13.5645 16.5939 13.5812 16.0087C12.488 16.0255 11.4037 16.0086 10.3281 15.9579Z"
      fill="hsl(from hsl(203 90% 47%) h s 81%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1734 15.9579C15.8271 16.0083 15.4713 16.0252 15.106 16.0087C15.106 16.5848 15.106 17.1609 15.106 17.7369C14.6146 17.7369 14.1233 17.7369 13.632 17.7369C13.632 17.72 13.632 17.703 13.632 17.6861C14.1063 17.6861 14.5808 17.6861 15.0552 17.6861C15.0552 17.11 15.0552 16.5339 15.0552 15.9579C15.4279 15.9579 15.8007 15.9579 16.1734 15.9579Z"
      fill="hsl(from hsl(203 90% 47%) h s 88%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.22759 16.3645C8.3289 16.3984 9.43016 16.4323 10.5315 16.4662C9.41272 16.4831 8.29449 16.4662 7.17676 16.4153C7.18306 16.3845 7.19999 16.3676 7.22759 16.3645Z"
      fill="hsl(from hsl(203 90% 47%) h s 87%)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.24528 17.4828C5.24528 17.5505 5.24528 17.6183 5.24528 17.6861C7.00736 17.6861 8.7694 17.6861 10.5315 17.6861C8.76116 17.7368 6.98215 17.7538 5.19445 17.7369C5.17999 17.6396 5.19693 17.5549 5.24528 17.4828Z"
      fill="hsl(from hsl(203 90% 47%) h s 91%)"
    />
  </svg>
);
